// Content data shared between the public pages and the build-time prerenderer
// (scripts/prerender.mjs). Icon components are mapped by name in the pages.

export const services = [
  {
    icon: 'Settings',
    title: "Custom Door Design",
    titleEt: "Erindis ukse disain",
    description: "Tailored door solutions to meet your specific requirements and architectural needs.",
    descriptionEt: "Sinu erinõuetele ja arhitektuurilistele vajadustele kohandatud ukselahendused.",
    features: ["Custom dimensions", "Material selection", "Hardware options", "Color matching"],
    featuresEt: ["Erimõõdud", "Materjalivalik", "Liigendite valik", "Toonide sobitus"]
  },
  {
    icon: 'Wrench',
    title: "Professional Installation",
    titleEt: "Professionaalne paigaldus",
    description: "Expert installation services ensuring perfect fit and optimal performance.",
    descriptionEt: "Asjatundlik paigaldusteenus, mis tagab täpse sobivuse ja optimaalse toimivuse.",
    features: ["Certified installers", "Quality guarantee", "Proper sealing", "Hardware setup"],
    featuresEt: ["Sertifitseeritud paigaldajad", "Kvaliteedigarantii", "Korrektne tihendus", "Liigendite seadistus"]
  },
  {
    icon: 'Truck',
    title: "Delivery & Logistics",
    titleEt: "Tarne ja logistika",
    description: "Reliable delivery services across Estonia and neighboring regions.",
    descriptionEt: "Usaldusväärne tarne üle Eesti ja naaberpiirkondades.",
    features: ["Secure packaging", "Timely delivery", "Installation scheduling", "Damage protection"],
    featuresEt: ["Turvaline pakend", "Õigeaegne tarne", "Paigalduse planeerimine", "Kahjustuste kaitse"]
  },
  {
    icon: 'HeadphonesIcon',
    title: "Technical Support",
    titleEt: "Tehniline tugi",
    description: "Comprehensive support from consultation to after-sales service.",
    descriptionEt: "Põhjalik tugi alates nõustamisest kuni müügijärgse teeninduseni.",
    features: ["Expert consultation", "Technical guidance", "Maintenance tips", "Warranty support"],
    featuresEt: ["Asjatundlik nõustamine", "Tehniline juhendamine", "Hooldusnõuanded", "Garantiitugi"]
  }
];

export const qualityFeatures = [
  {
    icon: 'CheckCircle',
    title: "CE Certification",
    titleEt: "CE-sertifikaat",
    description: "All our doors meet European Conformity standards for safety, health, and environmental protection.",
    descriptionEt: "Kõik meie uksed vastavad Euroopa Vastavuse (CE) ohutuse, tervise ja keskkonnakaitse standarditele.",
    details: ["EN 14351-1 compliance", "Performance testing", "Quality documentation", "Regular audits"],
    detailsEt: ["EN 14351-1 vastavus", "Toimivuse testimine", "Kvaliteedidokumentatsioon", "Regulaarsed auditid"]
  },
  {
    icon: 'Award',
    title: "Premium Materials",
    titleEt: "Kvaliteetsed materjalid",
    description: "We use quality-certified wood and high-grade components in our manufacturing process, with FSC-certified timber available.",
    descriptionEt: "Kasutame tootmises kvaliteedikontrollitud puitu ja kõrgekvaliteedilisi komponente, saadaval on FSC-sertifitseeritud puit.",
    details: ["FSC-certified timber available", "Premium hardware", "Quality insulation", "Durable finishes"],
    detailsEt: ["FSC-sertifitseeritud puit saadaval", "Kvaliteetsed liigendid", "Kvaliteetne isolatsioon", "Vastupidavad viimistlused"]
  },
  {
    icon: 'Shield',
    title: "Rigorous Testing",
    titleEt: "Põhjalik testimine",
    description: "Every door undergoes comprehensive testing for durability, weather resistance, and performance.",
    descriptionEt: "Iga uks läbib põhjaliku vastupidavuse, ilmastikukindluse ja toimivuse testimise.",
    details: ["Weather resistance", "Thermal performance", "Security testing", "Durability assessment"],
    detailsEt: ["Ilmastikukindlus", "Soojapidavus", "Turvalisuse testimine", "Vastupidavuse hindamine"]
  },
  {
    icon: 'Leaf',
    title: "Sustainable Production",
    titleEt: "Jätkusuutlik tootmine",
    description: "Committed to environmentally responsible manufacturing with sustainable materials and processes.",
    descriptionEt: "Oleme pühendunud keskkonnasõbralikule tootmisele jätkusuutlike materjalide ja protsessidega.",
    details: ["Eco-friendly materials", "Waste reduction", "Energy efficiency", "Carbon footprint reduction"],
    detailsEt: ["Keskkonnasõbralikud materjalid", "Jäätmete vähendamine", "Energiatõhusus", "Süsinikujalajälje vähendamine"]
  }
];

export const certifications = [
  { name: "CE Marking", description: "European Conformity certification (EN 14351-1)", descriptionEt: "Euroopa Vastavuse sertifikaat (EN 14351-1)" },
  { name: "FSC-Certified Materials", description: "FSC-certified timber available across the range", descriptionEt: "FSC-sertifitseeritud puit saadaval kogu valikus" },
  { name: "Energy Efficient", description: "Low U-value thermal performance (down to 0,77)", descriptionEt: "Madala U-väärtusega soojapidavus (kuni 0,77)" }
];

export const downloadCategories = [
  {
    icon: 'FileText',
    title: "Product Catalogs",
    titleEt: "Tootekataloogid",
    description: "Comprehensive catalogs with detailed specifications and technical information.",
    descriptionEt: "Põhjalikud kataloogid detailsete spetsifikatsioonide ja tehnilise infoga.",
    files: [
      { name: "SMARTLINE Door Catalog 2024", nameEt: "SMARTLINE ustekataloog 2024", size: "2.4 MB", type: "PDF" },
      { name: "Cottage Doors Specifications", nameEt: "Suvemaja uste spetsifikatsioonid", size: "1.8 MB", type: "PDF" },
      { name: "Meranti Doors Technical Guide", nameEt: "Meranti uste tehniline juhend", size: "1.2 MB", type: "PDF" }
    ]
  },
  {
    icon: 'Image',
    title: "Technical Drawings",
    titleEt: "Tehnilised joonised",
    description: "Detailed technical drawings and installation guides for all door models.",
    descriptionEt: "Detailised tehnilised joonised ja paigaldusjuhendid kõikidele uksemudelitele.",
    files: [
      { name: "Installation Guide - SMARTLINE", nameEt: "Paigaldusjuhend - SMARTLINE", size: "3.1 MB", type: "PDF" },
      { name: "Technical Drawings Package", nameEt: "Tehniliste jooniste pakett", size: "5.2 MB", type: "ZIP" },
      { name: "Hardware Installation Manual", nameEt: "Liigendite paigaldusjuhend", size: "2.7 MB", type: "PDF" }
    ]
  },
  {
    icon: 'Settings',
    title: "Certificates & Standards",
    titleEt: "Sertifikaadid ja standardid",
    description: "CE certificates, test reports, and compliance documentation.",
    descriptionEt: "CE-sertifikaadid, testiraportid ja vastavusdokumentatsioon.",
    files: [
      { name: "CE Certificate - SMARTLINE Series", nameEt: "CE-sertifikaat - SMARTLINE seeria", size: "0.8 MB", type: "PDF" },
      { name: "FSC Materials Documentation", nameEt: "FSC materjalide dokumentatsioon", size: "0.6 MB", type: "PDF" },
      { name: "Quality Test Reports", nameEt: "Kvaliteeditestide raportid", size: "1.4 MB", type: "PDF" }
    ]
  }
];
